import React, {useEffect, useState} from 'react';
import {Container} from "@mui/material";
import {connect} from "react-redux";
import {usersActions} from "../../modules/users/users.actions";
import {object, string} from 'yup';
import {FolderDelete} from "@mui/icons-material";
import {useParams} from "react-router-dom";
import {Formik} from "formik";
import PatrimoineDataField from "./patrimoine/form/PatrimoineDataField";
import {patrimoinesActions} from "../../modules/patrimoines/patrimoines.actions";
import SubmitButton from "./layout/forms/SubmitButton";
import PageTitle from "./layout/PageTitle";
import Loader from "./layout/loading/loader";
import Grid from "@mui/material/Grid2";

const patrimoineValidationSchema = object({
    libelle: string().required('Le libellé est requis'),
});

function PatrimoineNewOrEdit({dispatch, ...props}) {
    const params = useParams();
    const [userId, setUserId] = React.useState(null)
    const [patrimoineId, setPatrimoineId] = React.useState(null)
    const [mode, setMode] = useState("create");

    useEffect(() => {
        if (params.hasOwnProperty("id")) {
            setUserId(params.id);
        } else if (params.hasOwnProperty("patrimoineId")) {
            setPatrimoineId(params.patrimoineId)
            setMode("edit")
        }
    }, [params]);

    useEffect(() => {
        if (userId && !props.client && !props.loading && !props.error) {
            dispatch(usersActions.fetchUser('client', userId))
        } else {

            if (patrimoineId && (props.patrimoine?.id !== parseInt(patrimoineId)) && !props.loading && !props.error) {
                dispatch(patrimoinesActions.fetchPatrimoine(patrimoineId))
            }
        }

        if (patrimoineId && !props.client && !props.loading && !props.error) {
            dispatch(usersActions.fetchClients());
        }
    }, [props, dispatch])

    const initialValues = {
        libelle: props.patrimoine?.libelle || '',
        client: props.patrimoine?.client || null,
        // Type de patrimoine: Normal (false) ou Graffiti (true)
        isGraffiti: props.patrimoine?.isGraffiti ?? false,
        // Site au forfait : quantité réellement lavée variable et inconnue d'avance.
        // Si true, aucune anomalie ECART_QUANTITE n'est levée pour ce patrimoine.
        quantiteVariable: props.patrimoine?.quantiteVariable ?? false,
    }

    const handleSubmit = (values) => {
        // Nettoyage des anciens champs non utilisés
        delete values.lieu;
        delete values.nombreDeBacs;
        delete values.commentaire;
        delete values.isUnipatrimoine;

        dispatch(usersActions.clearUser());
        if (mode === "create") {
            values.client = props.client['@id'];
            dispatch(patrimoinesActions.createPatrimoine(values));
        } else {
            dispatch(patrimoinesActions.updatePatrimoine(values, patrimoineId))
        }
    }


    return (
        <>
            <PageTitle
                title={mode === "create" ? `Nouveau patrimoine pour ${props.client?.libelle}` : `Modifier le patrimoine ${props.patrimoine?.libelle}`}
                icon={<FolderDelete/>}/>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={patrimoineValidationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values)
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                  }) => (
                    <form onSubmit={handleSubmit}>
                        {props.loading &&
                            <Loader/>
                        }
                        {!props.loading &&
                            <>
                                <PatrimoineDataField values={values} errors={errors} handleChange={handleChange}
                                                     handleBlur={handleBlur} mode={mode} clients={props.clients} currentClient={props.client}/>
                                <Grid container justifyContent="center" style={{marginTop: '2rem'}}>
                                    <Grid size={4}>
                                        <SubmitButton submitting={isSubmitting && !props.error}/>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    </form>
                )}
            </Formik>
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        client: state.users.user,
        clients: state.users.clients,
        patrimoine: state.patrimoines.patrimoine,
        loading: state.users.loading || state.patrimoines.loading,
        error: state.users.error || state.patrimoines.error
    }
}

export default connect(mapStateToProps)(PatrimoineNewOrEdit);
